import { Box, VBox } from "@ui/box/Box";
import Button from "@ui/button/Button";
import { Checkbox } from "@ui/checkbox/Checkbox";
import Panel from "@ui/panel/Panel";
import { Rows } from "@ui/table/Rows";
import { CountriesData } from "@ui/utils/CountriesData";
import Signal from "badmfck-signal";
import { useEffect, useState } from "react";

export const S_SELECT_COUNTRIES_POPUP = new Signal<{
	onSuccess: (countries: ICountry[]) => void;
} | null>("S_SELECT_COUNTRIES_POPUP");

export const SelectCountriesPopup = () => {
	const requestData = S_SELECT_COUNTRIES_POPUP.use();
	// const [selectedChannels, setSelectedChannels] = useState<
	// 	IAcquirerChannel[]
	// >([]);

	const [countries, setCountries] =
		useState<((typeof CountriesData.countries)[number] & { selected: boolean; flag: string })[]>();

	const [selected, setSelected] = useState<number>(0);

	setSelected;

	useEffect(() => {
		if (requestData) {
			setCountries(
				CountriesData.countries.map(c => {
					return { ...c, selected: false, flag: c.alpha2 };
				})
			);
		}
	}, [requestData]);

	if (!requestData) return null;

	// const handleSubmit = async () => {
	// 	if (selectedAqcuirerChannels) {
	// 		setError(undefined);
	// 		setBusy(true);
	// 		const res = await GD.REQ_BANK_SAVE.request(form);
	// 		if (!res.error) {
	// 			closePopup();
	// 		} else {
	// 			setError(res.error);
	// 		}
	// 		setBusy(false);
	// 	}
	// };

	const closePopup = () => {
		S_SELECT_COUNTRIES_POPUP.invoke(null);
		setCountries(undefined);
		setSelected(0);
	};

	const updateSelected = () => {
		if (countries) {
			setSelected(countries.filter(c => c.selected).length);
		}
	};

	const onSubmit = async () => {
		requestData.onSuccess && countries && requestData.onSuccess(countries.filter(c => c.selected) as unknown as ICountry[]);
		closePopup();
	};

	return (
		<Panel
			sx={{
				maxWidth: "1200px",
				height: "86vh",
				padding: "0",
				minWidth: "600px",
			}}
			decorator="absolute"
			label="Select countries"
			onClose={closePopup}>
			<VBox
				gap="20px"
				sx={{
					overflow: "auto",
					flexGrow: 1,
					padding: "20px 20px",
					backgroundColor: "#EEF0F2",
				}}>
				<VBox gap="12px" sx={{ height: "100%" }}>
					{countries && (
						<VBox gap="12px" sx={{ height: "100%" }}>
							<Rows
								inlineItems
								searchable
								data={countries}
								order={["selected", "flag", "name", "alpha2"]}
								cellFactory={(row, cell, _index, _key, name, sx) => {
									if (name === "__itemType") {
										return { content: null };
									}
									if (name === "selected") {
										return {
											content: (
												<Checkbox
													name="selected"
													data={row}
													key={row.id}
													onChange={isAdd => {
														row.selected = isAdd;
														updateSelected();
													}}
												/>
											),
											sx,
										};
									}
									if (name === "flag") {
										return {
											content: (
												<Box
													sx={{
														borderRadius: "50%",
														backgroundSize: "cover",
														backgroundRepeat: "no-repeat",
														backgroundPosition: "center",
														width: "25px",
														height: "25px",
														border: "2px solid white",
														boxShadow: "0px 0px 4px rgba(0,0,0,.2)",
													}}
													style={{
														backgroundImage: `url('https://flagcdn.com/${row.alpha2?.toString().toLowerCase()}.svg')`,
													}}></Box>
											),
											sx: {
												...sx,
												padding: "10px 0px 10px 20px",
											},
										};
									}

									if (name === "name" || name === "alpha2")
										return {
											content: cell,
											sx,
										};

									return { content: null };
								}}
							/>
						</VBox>
					)}
				</VBox>
			</VBox>

			<VBox sx={{ padding: "20px", gap: "12px" }}>
				<Button
					title={selected > 0 ? `Add (${selected})` : "Close"}
					onClick={() => {
						selected > 0 ? onSubmit() : closePopup();
					}}
				/>
			</VBox>
		</Panel>
	);
};
